export default "__VITE_ASSET__Dz4qbRnq__"